import type { ReactNode } from "react";

import { lazy, StrictMode, Suspense } from "react";

import { ErrorBoundary } from "@sentry/react";
import { I18nProvider } from "react-aria-components";
import ReactDOM from "react-dom/client";

import "@shared/design-system-kit/index.css";
import { ReactQueryProvider } from "@shared/react-query";

import { ErrorMessage } from "./components/error-message";
import { FullScreenLoader } from "./components/full-screen-loader";
import { LDReactProvider } from "./contexts/launch-darkly.tsx";
import { initSentry } from "./utils/sentry-config.ts";

import "./css/index.css";

const LazyApp = lazy(() => {
	return import("./components/lazy-app/lazy-app.tsx").then((module) => {
		return { default: module.LazyApp };
	});
});

initSentry();

function App(): ReactNode {
	return (
		<StrictMode>
			<I18nProvider locale="en-GB">
				<LDReactProvider>
					<ErrorBoundary fallback={ErrorMessage}>
						<ReactQueryProvider>
							<Suspense fallback={<FullScreenLoader />}>
								<LazyApp />
							</Suspense>
						</ReactQueryProvider>
					</ErrorBoundary>
				</LDReactProvider>
			</I18nProvider>
		</StrictMode>
	);
}

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
ReactDOM.createRoot(document.getElementById("root")!).render(<App />);
